import React from "react";
import { useLang } from "../contexts/LanguageContext";
import { Truck } from "lucide-react";

const MobileBanner = () => {
  const { t } = useLang();
  return (
    <section className="py-20 relative overflow-hidden" data-testid="mobile-banner">
      <div className="container-hd">
        <div className="relative rounded-3xl border border-[color:var(--hd-gold)]/20 bg-gradient-to-br from-[#141414] to-[#0A0A0A] p-8 md:p-14 overflow-hidden">
          <div
            className="absolute -right-20 -top-20 w-80 h-80 rounded-full opacity-40 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, rgba(212,175,55,0.25) 0%, transparent 60%)",
              filter: "blur(40px)",
            }}
          />
          <div className="relative grid md:grid-cols-[auto,1fr] gap-8 items-center">
            <div className="w-20 h-20 rounded-full bg-[color:var(--hd-gold)]/10 border border-[color:var(--hd-gold)]/30 flex items-center justify-center">
              <Truck className="text-[color:var(--hd-gold)]" size={36} />
            </div>
            <div>
              <div className="font-serif italic text-[color:var(--hd-gold)] text-sm mb-2">
                {t.mobile.badge}
              </div>
              <h3 className="font-display text-2xl md:text-4xl font-bold text-white mb-3 tracking-tight">
                {t.mobile.title}
              </h3>
              <p className="text-white/60 text-base leading-relaxed max-w-2xl">
                {t.mobile.desc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileBanner;
